import { ERoleAccess } from "@/frontend/app/providers/router/config/routeConfig";
import $api from "@/frontend/shared/api/axios";
import { useMe } from "@/frontend/shared/lib/hooks/useMe";
import { useQuery } from "@tanstack/react-query";

export function getStageNames() {
  return $api.get("/tags");
}

type Tag = {
  id: string;
  name: string;
};

export function useTagNames() {
  const { data: userData } = useMe();

  const query = useQuery({
    queryKey: ["tagNames"],
    queryFn: async () => {
      const response = await $api.get<{ data: Tag[] }>("/tags/extra");
      return response.data.data;
    },
    enabled: userData?.entity === ERoleAccess.INVESTOR
  });

  return { ...query };
}
